var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBottomMenuCalendar = function SvgBottomMenuCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#9BA4C5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M2.754 10H22.75M8.086 6.668V2.002m9.332 4.666V2.002M4.087 21.998h17.33c.736 0 1.333-.597 1.333-1.333V6c0-.736-.597-1.333-1.333-1.333H4.087c-.736 0-1.333.597-1.333 1.333v14.664c0 .736.597 1.333 1.333 1.333"
  })));
};
export default SvgBottomMenuCalendar;